import * as busyCounter from '../action-creators/busy-counter';

import {getExcelForDownload} from '../repositories';
import {getFileName} from './get-file-name';
import {getStore} from '../../store-factory';
import {openFile} from './open-file';

export const exportToExcel = async url => {

    const dispatch = getStore().dispatch;

    dispatch(busyCounter.increaseBusyCounter());

    try {

        const response = await getExcelForDownload(url);

        const fileName = getFileName(response);

        const blob = await response.blob();

        openFile(blob, fileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

    } catch (error) {

    } finally {

        dispatch(busyCounter.decreaseBusyCounter());

    }

};



// WEBPACK FOOTER //
// ./src/shared/services/export-to-excel.js